import { render, staticRenderFns } from "./ItemRefundReasons.vue?vue&type=template&id=45bb3b04&scoped=true&"
import script from "./ItemRefundReasons.vue?vue&type=script&scoped=true&lang=js&"
export * from "./ItemRefundReasons.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./ItemRefundReasons.vue?vue&type=style&index=0&id=45bb3b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb3b04",
  null
  
)

export default component.exports